import React from 'react';

import palette from '../../color-palette';

const Specials = (props) => {
  const {
    primary: { main },
  } = palette;

  return (
    <svg
      id="Special_Category_svg__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -5 60 60"
      {...props}
    >
      <path
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".92px"
        d="M30 8.36l-9.39 14.43s6 .61 9.37.61 9.41-.61 9.41-.61z"
      />
      <path
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".92px"
        d="M22.88 23.1L16 35.06s9.3.61 14 .61 14-.61 14-.61l-6.91-12M33.02 49.59v7.99h-6.04v-7.99"
      />
      <path
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".92px"
        d="M19.35 35.36L11.49 49s13.16.61 18.49.61S48.51 49 48.51 49l-7.86-13.64M30.8 4.03l1.82.22-1.28 1.31.35 1.79-1.64-.81-1.59.89.26-1.81-1.34-1.24 1.8-.31.77-1.65.85 1.61z"
      />
      <circle
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".61px"
        cx={21.62}
        cy={42.14}
        r={1.01}
      />
      <circle
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".61px"
        cx={34.31}
        cy={39.22}
        r={1.01}
      />
      <circle
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".61px"
        cx={32.62}
        cy={46.42}
        r={1.01}
      />
      <circle
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".61px"
        cx={27.99}
        cy={28.37}
        r={1.01}
      />
      <circle
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".61px"
        cx={21.62}
        cy={32.27}
        r={1.01}
      />
      <circle
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".61px"
        cx={32.62}
        cy={18.45}
        r={1.01}
      />
      <circle
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".61px"
        cx={29.49}
        cy={13.45}
        r={1.01}
      />
      <circle
        fill="none"
        stroke={main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".61px"
        cx={38.93}
        cy={32.77}
        r={1.01}
      />
    </svg>
  );
};

export default Specials;
